export const uk = {
    'add-description': {
        one: 'Креатив будет изменен в {count} объявлении.',
        some: 'Креатив будет изменен в {count} объявлениях.',
        many: 'Креатив будет изменен в {count} объявлениях.',
        none: 'Нет подходящих креативов для замены в выбранных объявлениях.'
    },
    'duplicate-error': 'При массовом изменении можно выбрать только одно изображение для каждого размера',
    warning:
        'Креатив в объявлении можно заменить только на креатив того же размера, созданный тем же способом, что и оригинал.'
};
